import type { Product } from '../types/product'
import { images } from './images'

export const products: Product[] = [
  {
    slug: 'hammam-ritueel-set',
    name: 'Hammam Ritueel Set',
    subtitle: 'Alles voor het complete ritueel',
    category: 'sets',
    audiences: ['haar', 'hem'],
    badges: ['bestseller', 'cadeau'],
    image: images.giftset,
    gallery: [images.giftset, images.ritual, images.flatlay],
    variants: [{ id: 'set', label: 'Complete set', price: 59.95, compareAt: 69.75 }],
    rating: 4.9,
    reviews: 318,
    benefit: 'Vijf essentials in één doos: reinigen, scrubben, behandelen, opfrissen en voeden.',
    what: 'Een complete set met Savon Beldi, een Kessa, Ghassoul, Rozenwater en Arganolie — de kern van het Marokkaanse hammam-ritueel.',
    does: 'Reinigt, exfolieert en verzorgt de huid in vijf stappen. De huid voelt gladder, zachter en soepeler aan.',
    use: 'Volg de volgorde in de doos: zeep op de warme huid, scrubben met de kessa, kleimasker, rozenwater als mist en eindigen met arganolie.',
    includes: ['savon-beldi', 'kessa', 'ghassoul', 'rozenwater', 'arganolie'],
  },
  {
    slug: 'arganolie',
    name: 'Arganolie',
    subtitle: 'Voor huid, haar en baard',
    category: 'olien',
    audiences: ['haar', 'hem'],
    badges: ['bestseller'],
    image: images.argan,
    gallery: [images.argan, images.hero, images.story],
    variants: [
      { id: '30ml', label: '30 ml', price: 19.95 },
      { id: '50ml', label: '50 ml', price: 29.95 },
      { id: '100ml', label: '100 ml', price: 49.95 },
    ],
    rating: 4.9,
    reviews: 704,
    benefit: 'Houdt de huid soepel en verzacht het haar.',
    what: 'Plantaardige olie uit de vrucht van de arganboom, met oliezuur en linolzuur en rijk aan tocoferolen.',
    does: 'Verzacht en verzorgt het haar, houdt de huid soepel en ondersteunt het vasthouden van vocht.',
    use: 'Breng een paar druppels aan op de licht vochtige huid, in de haarpunten of in de baard.',
    ritualStep: 8,
  },
  {
    slug: 'savon-beldi',
    name: 'Savon Beldi',
    subtitle: 'Zwarte zeep · Savon Noir',
    category: 'reiniging',
    audiences: ['haar', 'hem'],
    badges: ['bestseller'],
    image: images.savon,
    gallery: [images.savon, images.ritual, images.souk],
    variants: [
      { id: '250g', label: '250 g', price: 14.95 },
      { id: '500g', label: '500 g', price: 24.95 },
    ],
    rating: 4.8,
    reviews: 412,
    benefit: 'Rijke zeeppasta die de huid voorbereidt op de kessa.',
    what: 'Traditionele Marokkaanse zeep in de vorm van een zachte, rijke pasta, gemaakt op basis van olijf en een alkalisch verzepingsmiddel.',
    does: 'Reinigt en verzacht de huid, zodat dode huidcellen makkelijker loskomen bij het scrubben.',
    use: 'Breng aan op de warme, vochtige huid. Laat 5–10 minuten intrekken, spoel af en scrub met de Kessa.',
    ritualStep: 2,
  },
  {
    slug: 'kessa',
    name: 'Kessa',
    subtitle: 'Exfoliërende handschoen',
    category: 'scrubtools',
    audiences: ['haar', 'hem'],
    badges: ['bestseller'],
    image: images.kessa,
    gallery: [images.kessa, images.ritual],
    variants: [
      { id: 'fijn', label: 'Fijn', price: 9.95 },
      { id: 'stevig', label: 'Stevig', price: 9.95 },
    ],
    rating: 4.9,
    reviews: 538,
    benefit: 'Maakt dode huidcellen los voor een gladdere huid.',
    what: 'Handschoen met een stevige, geweven textuur, traditioneel gebruikt in de hammam.',
    does: 'Maakt oppervlakkige dode huidcellen en schilfers los, waardoor de huid gladder en zachter aanvoelt.',
    use: 'Scrub na de Savon Beldi met lange halen over de natte huid. Spoel de handschoen na gebruik uit en laat drogen.',
    ritualStep: 3,
  },
  {
    slug: 'ghassoul',
    name: 'Ghassoul',
    subtitle: 'Minerale klei uit het Atlasgebergte',
    category: 'reiniging',
    audiences: ['haar', 'hem'],
    badges: ['bestseller'],
    image: images.ghassoul,
    gallery: [images.ghassoul, images.souk],
    variants: [
      { id: '200g', label: '200 g', price: 12.95 },
      { id: '400g', label: '400 g', price: 21.95 },
    ],
    rating: 4.7,
    reviews: 286,
    benefit: 'Zuiverend kleimasker voor huid en haar.',
    what: 'Natuurlijke minerale klei uit de Moulouya-vallei, rijk aan magnesiumhoudende kleimineralen van de stevensietgroep.',
    does: 'Reinigt huid en haar zacht, zonder het uit te drogen.',
    use: 'Meng met water of rozenwater tot een pasta, breng aan, laat 5–10 minuten zitten en spoel af.',
    ritualStep: 4,
  },
  {
    slug: 'rozenwater',
    name: 'Rozenwater',
    subtitle: 'Damascusroos · toner & mist',
    category: 'bloemenwater',
    audiences: ['haar'],
    badges: ['bestseller'],
    image: images.rosewater,
    gallery: [images.rosewater, images.ritual],
    variants: [
      { id: '100ml', label: '100 ml', price: 11.95 },
      { id: '250ml', label: '250 ml', price: 19.95 },
    ],
    rating: 4.8,
    reviews: 359,
    benefit: 'Verfrissende toner die geen vette laag achterlaat.',
    what: 'Aromatisch bloemenwater, gedistilleerd uit de blaadjes van de Damascusroos.',
    does: 'Verfrist en verzorgt de huid, bevat antioxidatieve eigenschappen en laat geen olieachtige laag achter.',
    use: 'Spray op gezicht en lichaam na het reinigen, of gebruik als toner op een wattenschijfje.',
    ritualStep: 7,
  },
  {
    slug: 'cactusvijgolie',
    name: 'Cactusvijgolie',
    subtitle: 'Prickly pear seed oil',
    category: 'olien',
    audiences: ['haar'],
    badges: ['nieuw'],
    image: images.cactus,
    gallery: [images.cactus, images.hero],
    variants: [
      { id: '15ml', label: '15 ml', price: 34.95 },
      { id: '30ml', label: '30 ml', price: 59.95 },
    ],
    rating: 4.8,
    reviews: 97,
    benefit: 'Gezichtsolie tegen een trekkerig gevoel.',
    what: 'Olie uit de vrucht van de Opuntia ficus-indica, met een zeer hoog percentage linolzuur, plus tocoferolen en fytosterolen.',
    does: 'Maakt de huid glad en soepel en helpt de huidbarrière te behouden.',
    use: 'Verwarm 2–3 druppels tussen je vingers en druk zacht op gezicht en hals, ’s avonds of ’s ochtends.',
    ritualStep: 8,
  },
  {
    slug: 'nila',
    name: 'Nila',
    subtitle: 'Nila Sahraouia · blauw poeder',
    category: 'reiniging',
    audiences: ['haar'],
    badges: ['nieuw'],
    image: images.nila,
    gallery: [images.nila, images.souk],
    variants: [{ id: '50g', label: '50 g', price: 16.95 }],
    rating: 4.6,
    reviews: 64,
    benefit: 'Diepblauw masker uit de Sahara.',
    what: 'Fijn, diepblauw poeder afkomstig uit de Sahara.',
    does: 'Een traditioneel masker voor een frisse, egale uitstraling van de gezuiverde huid.',
    use: 'Meng tot een zachte pasta en breng als masker aan op de gezuiverde huid. Spoel na 10 minuten af.',
    ritualStep: 4,
  },
  {
    slug: 'tbrima',
    name: 'Tbrima',
    subtitle: 'Kruidenpoeder voor de huid',
    category: 'reiniging',
    audiences: ['haar'],
    badges: ['nieuw'],
    image: images.flatlay,
    gallery: [images.flatlay, images.souk],
    variants: [{ id: '100g', label: '100 g', price: 14.95 }],
    rating: 4.6,
    reviews: 38,
    benefit: 'Eigen kruidenmengsel, fijngemalen.',
    what: 'Kruidenpoeder van fijngemalen planten en natuurlijke poeders, samengesteld volgens ons eigen mengsel.',
    does: 'Een traditionele bodytreatment die de huid verzorgt na het reinigen.',
    use: 'Meng met water of rozenwater tot een zachte pasta en breng aan op een vochtige huid.',
    ritualStep: 4,
  },
  {
    slug: 'oranjebloesemwater',
    name: 'Oranjebloesemwater',
    subtitle: 'Bittere sinaasappelbloesem',
    category: 'bloemenwater',
    audiences: ['haar', 'hem'],
    badges: [],
    image: images.orangeblossom,
    gallery: [images.orangeblossom, images.ritual],
    variants: [
      { id: '100ml', label: '100 ml', price: 11.95 },
      { id: '250ml', label: '250 ml', price: 19.95 },
    ],
    rating: 4.7,
    reviews: 143,
    benefit: 'Frisse gezichtsmist, ook ideaal na het scheren.',
    what: 'Bloemenwater uit stoomdestillatie van de bloesems van de bittere sinaasappelboom.',
    does: 'Verfrist de huid, heeft antioxidatieve eigenschappen en laat geen vettige laag achter.',
    use: 'Gebruik als gezichtsmist of toner na het reinigen.',
    ritualStep: 7,
  },
  {
    slug: 'musk',
    name: 'Musk',
    subtitle: 'Geurolie · warm & zacht',
    category: 'geur',
    audiences: ['haar', 'hem'],
    badges: ['cadeau'],
    image: images.perfume,
    gallery: [images.perfume, images.hero],
    variants: [{ id: '10ml', label: '10 ml', price: 24.95 }],
    rating: 4.8,
    reviews: 267,
    benefit: 'Subtiele geur die zich de hele dag ontwikkelt.',
    what: 'Een warme, zachte en langdurige geurolie.',
    does: 'Blijft subtiel op de huid hangen en ontwikkelt zich gedurende de dag.',
    use: 'Breng een kleine hoeveelheid aan op polsen, hals of achter de oren.',
    ritualStep: 9,
  },
  {
    slug: 'oud',
    name: 'Oud',
    subtitle: 'Geurolie · diep & houtachtig',
    category: 'geur',
    audiences: ['hem', 'haar'],
    badges: ['bestseller', 'cadeau'],
    image: images.perfume,
    gallery: [images.perfume, images.him],
    variants: [{ id: '10ml', label: '10 ml', price: 29.95 }],
    rating: 4.8,
    reviews: 189,
    benefit: 'Rijke, houtachtige geur met karakter.',
    what: 'Een diepe, warme en houtachtige geurolie met een rijk en langdurig karakter.',
    does: 'Ontwikkelt zich geleidelijk op de huid tot een intense, warme geur.',
    use: 'Breng een kleine hoeveelheid aan op polsen, hals of achter de oren.',
    ritualStep: 9,
  },
  {
    slug: 'geurset-musk-oud',
    name: 'Geurset Musk & Oud',
    subtitle: 'Twee geuroliën in cadeauverpakking',
    category: 'sets',
    audiences: ['haar', 'hem'],
    badges: ['cadeau'],
    image: images.perfume,
    gallery: [images.perfume, images.him, images.hero],
    variants: [{ id: 'set', label: '2 × 10 ml', price: 49.95, compareAt: 54.9 }],
    rating: 4.8,
    reviews: 74,
    benefit: 'Zacht én diep: voor elk moment een geur.',
    what: 'Musk en Oud samen in een cadeauverpakking.',
    does: 'Musk voor overdag, Oud voor de avond — of combineer ze.',
    use: 'Breng een kleine hoeveelheid aan op polsen, hals of achter de oren.',
    includes: ['musk', 'oud'],
  },
  {
    slug: 'henna-sidr',
    name: 'Henna Sidr',
    subtitle: 'Plantaardige haarverzorging',
    category: 'make-up-haar',
    audiences: ['haar', 'hem'],
    badges: [],
    image: images.henna,
    gallery: [images.henna, images.story],
    variants: [
      { id: '100g', label: '100 g', price: 13.95 },
      { id: '200g', label: '200 g', price: 22.95 },
    ],
    rating: 4.7,
    reviews: 210,
    benefit: 'Verzorgt en kleurt het haar op natuurlijke wijze.',
    what: 'Haarverzorging op basis van henna en sidr. Het kleurende bestanddeel lawsone reageert met keratine.',
    does: 'Verzorgt het haar en geeft een langdurige hennakleur.',
    use: 'Meng met warm water tot een pasta, breng aan op het haar en laat 1–3 uur intrekken.',
    ritualStep: 5,
  },
  {
    slug: 'rozenblaadjes',
    name: 'Rozenblaadjes',
    subtitle: 'Gedroogde Damascusroos',
    category: 'bloemenwater',
    audiences: ['haar'],
    badges: ['cadeau'],
    image: images.petals,
    gallery: [images.petals, images.souk],
    variants: [{ id: '50g', label: '50 g', price: 9.95 }],
    rating: 4.6,
    reviews: 88,
    benefit: 'Voor in bad of door je kleimasker.',
    what: 'Gedroogde bloemblaadjes met polyfenolen, flavonoïden en natuurlijke kleurstoffen zoals anthocyanen.',
    does: 'Bevat antioxidatieve verbindingen en geeft een zachte rozengeur.',
    use: 'Voeg toe aan warm badwater, of maal fijn en meng met ghassoul voor een gezichtsmasker.',
  },
  {
    slug: 'kohl',
    name: 'Kohl',
    subtitle: 'Natuurlijke oogomlijning',
    category: 'make-up-haar',
    audiences: ['haar'],
    badges: [],
    image: images.beauty,
    gallery: [images.beauty, images.hero],
    variants: [{ id: 'std', label: 'Zwart', price: 11.95 }],
    rating: 4.6,
    reviews: 156,
    benefit: 'Diepe zwarte lijn, op traditionele wijze.',
    what: 'Een natuurlijk oogcosmeticum voor het omlijnen van de ogen.',
    does: 'Geeft zwarte of donkergrijze lijnen.',
    use: 'Haal het stokje door het poeder en trek het zacht langs de waterlijn.',
  },
  {
    slug: 'aker-fassi',
    name: 'Aker Fassi',
    subtitle: 'Natuurlijk pigment voor lippen & wangen',
    category: 'make-up-haar',
    audiences: ['haar'],
    badges: [],
    image: images.beauty,
    gallery: [images.beauty, images.hero],
    variants: [{ id: 'std', label: '15 g', price: 12.95 }],
    rating: 4.5,
    reviews: 72,
    benefit: 'Een natuurlijke blos, van klaproos en granaatappel.',
    what: 'Fijngemalen gedroogde rode klaproosblaadjes en granaatappelschil: een sterk gepigmenteerd poeder.',
    does: 'Geeft wangen en lippen een rode of roze tint.',
    use: 'Activeer met een druppel water of rozenwater en dep op wangen of lippen.',
  },
  {
    slug: 'mhekka',
    name: "M'hekka",
    subtitle: 'Voetsteen van terracotta',
    category: 'scrubtools',
    audiences: ['haar', 'hem'],
    badges: [],
    image: images.mhekka,
    gallery: [images.mhekka],
    variants: [{ id: 'std', label: 'Eén maat', price: 8.95 }],
    rating: 4.7,
    reviews: 121,
    benefit: 'Voor ruwe hielen, knieën en ellebogen.',
    what: 'Traditionele steen voor het verzorgen van ruwe en verharde huid.',
    does: 'Verzacht eelt en verharde plekken.',
    use: 'Gebruik op de natte huid na het baden, vooral op voeten, hielen, knieën en ellebogen.',
    ritualStep: 3,
  },
]
